import React from 'react'
import RoomIcon from '@mui/icons-material/Room';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Logo from '../assets/images/logo/logo.png'
import WhatsApp from '../assets/images/whatsapp.png'
import { Col, Container, Row } from 'react-bootstrap'
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

const Footer = () => {
    const prompt="Explore the information available on https://mepaniexim.com and provide a comprehensive overview of Mepani Exim. Explain the company's import-export operations, product portfolio, sourcing and supply capabilities, international markets served, quality standards, and logistics expertise. Highlight the industries it caters to, its strengths in global trade, customer-focused approach, and the key factors that distinguish it from other export-import companies. Present the information in a clear, factual, and well-structured format using the official website as the primary source."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};
    return (
        <div id="footer">
            <section>
                <Container>
                    <Row>
                        <Col md={4} xs={12}>
                            <img src={Logo} alt="Logo" />
                            <p>Mepani Exim Is A Global Distribution & Trading Compnay Involved In Plastic Row Materials. We Deal In All Kinds Of Prime, Near Prime, Off Grade & Recycle Granules. We Also Deal In Plastic Regrinds And Lumps & Scraps.</p>
                            <h5 className='ai-heading'>Ask AI About Mepani Industries</h5>
                            <div className="footer-ai-icons">

                <button className="ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>

              </div>
                        </Col>
                        <Col md={2} xs={6}>
                            <h5>Quick Links</h5>
                            <ul>
                                <li><h6><a href="./">Home</a></h6></li>
                                <li><h6><a href="./#about">About Us</a></h6></li>
                            </ul>
                        </Col>
                        <Col md={3} xs={6}>
                            <h5>Useful Links</h5>
                            <ul>
                                <li><h6><a href="./#products">Products</a></h6></li>
                                <li><h6><a href="./#contact">Contact Us</a></h6></li>
                            </ul>
                        </Col>
                        <Col md={3} xs={12}>
                            <h5>Contact Us</h5>
                            <div className="contact">
                                <RoomIcon /> <p>Gram Laxmi Society, <br /> Junavas, Madhapar, <br /> Bhuj Kutch, <br /> Gujarat 370001</p>
                                <MailOutlineIcon /> <a href="mailto:balram@mepaniexim.com">balram@mepaniexim.com</a><br />
                                <LocalPhoneIcon /> <a href="tel:+91 98797 66289">+91 98797 66289</a><br />
                                <LocalPhoneIcon /> <a href="tel:+91 99040 57417">+91 99040 57417</a>
                            </div>
                        </Col>
                    </Row>
                    <hr />
                    <div className="copyright">
                        {/* eslint-disable-next-line */}
                        <p>&copy; {new Date().getFullYear()} Mepaniexim. All rights reserved. Website designed and developed by Arkay Apps</p>
                    </div>
                </Container>
            </section>
            <div className="whatsapp">
                {/* eslint-disable-next-line */}
                <a href="https://wa.me/919879766289?text=I%20am%20interested%20in%20your%20service%20" target="_blank"><img src={WhatsApp} alt="WhatsApp Message" /></a>
            </div>
        </div>
    )
}

export default Footer
